import React, { useEffect } from "react";
import { View, Text, StyleSheet, ScrollView } from "react-native";
import { globalFontStyle, globalStyle } from "../../../assets";
import Header from "../../../commonComponents/Header";
import ListOfTrades from "../childComponents/listOfTrades";
import { connect } from "react-redux";
import { getClosedMarketProbe } from "../redux/portfolio.action";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { isMobile, trackMoengageEvent } from "../../../utils/commonMethods";
import Colors from "../../../assets/Color/Colors";
import EventDetailsBox from "../../event/childComponents/EventDetailsBox";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const ClosedPortfolioDetail = ({
  selectedClosedProbe1,
  navigation,
  getClosedMarketProbe,
  route,
  closedMarketDetailProbe,
}) => {
  const insets = useSafeAreaInsets();
  let selectedClosedProbe;
  if (isMobile()) {
    selectedClosedProbe = route?.params?.selectedClosedProbe;
  } else {
    selectedClosedProbe = selectedClosedProbe1;
  }
  // const {selectedClosedProbe} = route.params;
  useEffect(() => {
    getClosedMarketProbe({ probeid: selectedClosedProbe?.probeid });
  }, [selectedClosedProbe]);

  useEffect(() => {
    closedMarketDetailProbe &&
      trackMoengageEvent("Clicked on Closed Event", {
        Category: selectedClosedProbe?.category,
        id: selectedClosedProbe?.probeid,
        MarketOpen: new Date(selectedClosedProbe?.start_date),
        MarketEnd: new Date(selectedClosedProbe?.endsat),
        MarketSettlement: new Date(selectedClosedProbe?.settledate),
        SettlementLink: selectedClosedProbe?.source,
        ProofSettlement: closedMarketDetailProbe[0]?.proofofsettlement,
        Type: selectedClosedProbe?.is_price_editable ? "CDA" : "IM",
        SubCategory: selectedClosedProbe?.subcat,
        Status:
          closedMarketDetailProbe[0]?.totalrefund +
            closedMarketDetailProbe[0]?.totalreturn >
          closedMarketDetailProbe[0]?.totalinvested
            ? "Win"
            : "Lose",
        ///totalinvested,totalrefund,totalreturn
      });
  }, [closedMarketDetailProbe]);

  return (
    <View
      style={
        isMobile()
          ? { flex: 1 }
          : {
              borderWidth: 0.75,
              borderColor: globalConfigurableData.borderColor,
              borderRadius: 8,
              overflow: "hidden",
            }
      }
    >
      <ScrollView
        style={[
          globalStyle.pageContainer,
          {
            paddingTop: insets.top,
            paddingBottom: insets.bottom,
            // paddingLeft: insets.left,
            // paddingRight: insets.right,
          },
        ]}
        contentContainerStyle={{ flexGrow: 1, paddingBottom: 30 }}
      >
        {isMobile() && (
          <Header isInternalPage={false} navigation={navigation} />
        )}
        <View
          style={isMobile() ? { paddingHorizontal: 0, paddingVertical: 8 } : {}}
        >
          <View
            style={
              isMobile()
                ? { flexDirection: "row", alignContent: "center" }
                : {
                    alignItems: "center",
                    backgroundColor: Colors.tradexBlue1,
                    flexDirection: "row",
                    paddingVertical: 5,
                  }
            }
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                flex: 1,
              }}
            >
              <View style={{ paddingHorizontal: 16, flex: 1 }}>
                <Text
                  style={[
                    globalFontStyle.appFontHeading,
                    { color: globalConfigurableData.primaryTextColor1, flexWrap: "wrap", flex: 1 },
                  ]}
                  numberOfLines={3}
                >
                  {selectedClosedProbe?.title} {"\n"}(
                  <FormTextLabel
                    labelStyles={[globalFontStyle.appFontHeadingRegular]}
                    label={"Outcome"}
                  />
                  -{" "}
                  <FormTextLabel
                    labelStyles={[
                      globalFontStyle.appFontHeading,
                      {
                        color:
                          selectedClosedProbe?.correctvalue === "Y"
                            ? GlobalScreens.Event.yesBtnTxt
                            : GlobalScreens.Event.noBtnTxt,
                      },
                    ]}
                    label={selectedClosedProbe?.correctvalue === "Y" ? "Yes" : "No"}
                  />
                  )
                </Text>
                <Text
                  style={[
                    globalFontStyle.appFontBody,
                    { color: globalConfigurableData.secondaryTextColor1 },
                  ]}
                  numberOfLines={1}
                >
                  {selectedClosedProbe?.subtitle}
                </Text>
              </View>
              {/*<ProbeIcon eventUrl={_eventInfo?.imageurl} />*/}
            </View>
          </View>

          <View
            style={{
              paddingHorizontal: 18,
              paddingVertical: 8,
            }}
          >
            {closedMarketDetailProbe ? (
              <EventDetailsBox
                title={"List of Trades"}
                eventDetails={selectedClosedProbe}
                _eventInfo={selectedClosedProbe}
                isListOfTrades={closedMarketDetailProbe[0]?.orders}
              />
            ) : null}
            {closedMarketDetailProbe ? (
              <EventDetailsBox
                text={selectedClosedProbe?.resolution}
                title={"Market Resolution(MR)"}
                eventDetails={selectedClosedProbe}
                _eventInfo={selectedClosedProbe}
              />
            ) : null}
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

const mapStateToProps = ({ portfolioReducer }) => ({
  closedMarketDetailProbe: portfolioReducer.closedMarketDetailProbe,
  //selectedClosedProbe: liveProbes.selectedClosedProbe,
});

const mapDispatchToProps = {
  getClosedMarketProbe,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClosedPortfolioDetail);

const styles = StyleSheet.create({
  closedHeaderTitle: {
    ...globalFontStyle.appFontHeading,
    lineHeight: 26,
    color: "rgba(0, 0, 0, 0.8)",
    paddingHorizontal: 18,
    paddingVertical: 8,
  },
  closedHeaderTitleWeb: {
    ...globalFontStyle.appFontHeading,
    lineHeight: 26,
    color: "rgba(0, 0, 0, 0.8)",
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
});
